import { createBrowserHistory as createHistory } from "history"
import pick from "lodash/pick"
import queryString from "query-string"

const history = createHistory()

export function addParam(param, val, replace = false) {
    // Always get the latest search params from window.location
    let q = queryString.parse(window.location.search)

    // Update or add the new parameter
    q[param] = val

    // Convert back to a query string
    const updatedSearch = queryString.stringify(q)

    // Push or replace the new state in history
    if (!replace) {
        history.push({
            search: updatedSearch,
        })
    } else {
        history.replace({
            pathname: window.location.pathname,
            search: updatedSearch,
        })
    }
}
export function addParams(params, replace) {
    // Always get the latest search params from window.location
    let q = queryString.parse(window.location.search)

    params.forEach((p) => {
        q[p.param] = p.value
    })

    if (replace) {
        history.replace({
            search: queryString.stringify(q),
        })
    } else {
        history.push({
            search: queryString.stringify(q),
        })
    }
}

/**
 * Moves to a place in one history entry and tells every screen about it.
 *
 * A push on this shared history only reaches the App. Org, OrgFinancials, OrgVendors
 * and TimeTracking each listen to a history object of their own, so an organisation
 * that is already open would keep its tab. A popstate reaches all of them, the way
 * the Back button does, and they re-read the URL (mAX's navigate moves the same way).
 *
 * @param input {Object}
 * @param [input.remove] {String|String[]} Params to drop (comma separated or array)
 * @param [input.add] {Array<{param: String, value: String}>}
 * @param [input.replace] {Boolean} Replace the current entry instead of adding one
 */
export function goToParams({ remove = "", add = [], replace = false }) {
    let q = queryString.parse(window.location.search)

    const toRemove = Array.isArray(remove) ? remove : remove.split(",")
    toRemove.filter(Boolean).forEach((p) => delete q[p.trim()])
    add.forEach((p) => {
        q[p.param] = p.value
    })

    const search = queryString.stringify(q)

    if (replace) {
        history.replace({ pathname: window.location.pathname, search })
    } else {
        history.push({ pathname: window.location.pathname, search })
    }

    window.dispatchEvent(new PopStateEvent("popstate", { state: window.history.state }))
}

export function removeQueryParam(param) {
    // Always get the latest search params from window.location
    let q = queryString.parse(window.location.search)

    delete q[param]

    // Go through the shared history instance (not the raw browser API) so its
    // internal bookkeeping stays in sync and back/forward navigation keeps working.
    history.replace({
        pathname: window.location.pathname,
        search: queryString.stringify(q),
    })
}

export function removeParam(param, replace) {
    // Always get the latest search params from window.location
    let q = queryString.parse(window.location.search)

    delete q[param]

    if (replace) {
        history.replace({
            search: queryString.stringify(q),
        })
    } else {
        history.push({
            search: queryString.stringify(q),
        })
    }
}
export function removeParams(stringParams, replace) {
    let params = stringParams.split(",")

    // Always get the latest search params from window.location
    let q = queryString.parse(window.location.search)

    params.forEach((p) => {
        delete q[p]
    })

    if (replace) {
        history.replace({
            search: queryString.stringify(q),
        })
    } else {
        history.push({
            search: queryString.stringify(q),
        })
    }
}
export function getQ() {
    // Always get the latest search params from window.location
    return queryString.parse(window.location.search)
}

/**
 * @param [key] {string|string[]} A single or multiple keys to return values for
 * @return {string|object|undefined}
 */
export function getHash(key) {
    let hash = history.location.hash
    const hashObj = hash
        ? hash
              .slice(1)
              .split("&")
              .reduce((result, item) => {
                  let parts = item.split("=")
                  result[parts[0]] = parts[1]
                  return result
              }, {})
        : null

    if (!hashObj) {
        return
    }

    if (typeof key === "string") {
        return hashObj[key]
    }

    if (Array.isArray(key)) {
        return pick(hashObj, key)
    }

    return hashObj
}

export default history
